import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { UserRights } from '@maximizer/core/shared/domain';
import {
  OnboardingStepNumber,
  StepGuideId,
} from '@maximizer/outlook/shared/data-access';
import { OutlookEmail } from '@maximizer/outlook/shared/domain';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import {
  KENDO_LISTVIEW,
  PagerSettings,
} from '@progress/kendo-angular-listview';
import { PageChangeEvent } from '@progress/kendo-angular-pager';
import { KENDO_TOOLTIPS } from '@progress/kendo-angular-tooltip';
import { DataResult, State } from '@progress/kendo-data-query';
import { OutlookReadEntryRowComponent } from '../entry-row/entry-row.component';

interface InMaximizerLoadingState {
  skeleton: boolean;
  syncSubscriptions: boolean;
}

@Component({
  selector: 'maximizer-outlook-in-maximizer-list',
  templateUrl: './in-maximizer-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    KENDO_BUTTONS,
    KENDO_LISTVIEW,
    KENDO_TOOLTIPS,
    OUTLOOK_SHARED_UI,
    OutlookReadEntryRowComponent,
    TranslatePipe,
  ],
})
export class OutlookInMaximizerListComponent {
  entries = input<OutlookEmail[]>([]);
  dataResult = input.required<DataResult>();
  state = input.required<State>();
  pagerSettings = input<PagerSettings | boolean>(false);
  loading = input<InMaximizerLoadingState>({
    skeleton: true,
    syncSubscriptions: false,
  });
  disableSaveAll = input<boolean>(false);
  saveAllTooltip = input<string>('');
  saveAllDisabled = input<boolean>(false);

  onboardingInProgress = input<boolean>(false);
  currentGuide = input<StepGuideId | undefined>(undefined);
  currentStep = input<OnboardingStepNumber | undefined>(undefined);
  entryActionsGuideVisible = input<boolean>(false);

  userRights = input<UserRights | undefined>(undefined);
  userEmails = input<Set<string>>(new Set());
  autoSaveEnabledIds = input<string[]>([]);

  pageChange = output<PageChangeEvent>();
  saveAll = output<void>();
  navigateEntry = output<OutlookEmail>();
  saveEntry = output<{ entry: OutlookEmail; fromPopup: boolean }>();

  readonly OnboardingStepNumber = OnboardingStepNumber;
  readonly StepGuideId = StepGuideId;
}
